import React, { useState, useRef, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import Breakpoint from 'react-socks';
import onClickOutside from 'react-cool-onclickoutside';
import Portal from '../../Portal';
import PriceView from '../Views/PriceView';
import Itinerary from './Itinerary';
import PrimaryButton from '../FormFields/PrimaryButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function Cruisemaster(props) {
  const styledImage = {
    backgroundImage: `linear-gradient(to top, rgba(159,211,223, 1), rgba(159,211,223, 0) 80%)`,
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  };

  const priceRef = useRef();
  onClickOutside(priceRef, () => setShowPrice(false));
  const itineraryRef = useRef();
  onClickOutside(itineraryRef, () => setShowItinerary(false));

  const [showPrice, setShowPrice] = useState(false);
  const [showItinerary, setShowItinerary] = useState(false);
  const [showAllDates, setShowAllDates] = useState(false);

  const desktopLayout = {
    gridTemplateAreas:
      `'shipImage shipImage headline  headline  headline  headline  price      price     '
       'shipImage shipImage itinerary itinerary itinerary itinerary extraInfo  extraInfo '
       'shipImage shipImage itinerary itinerary itinerary itinerary extraInfo  extraInfo '
       `
  };
  const ipadVerticalLayout = {
    gridTemplateAreas:
      ` '.          price'
        'shipImage  shipImage '
        'headline   headline '
        'itinerary  itinerary '
        'extraInfo  extraInfo '
       `
  };

  function sumOfPassengers(priceGrid) {
    let sum = 0;
    if (priceGrid.adults) sum += priceGrid.adults;
    if (priceGrid.seniors) sum += priceGrid.seniors;
    if (priceGrid.children) sum += priceGrid.children;
    if (priceGrid.juniorChildren) sum += priceGrid.juniorChildren;
    if (priceGrid.infants) sum += priceGrid.infants;
    return sum;
  }
  function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
      var key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }
  function renderCabintypes() {
    let cp = props.cruisemaster.cruisePackages.find(x => x.departure === props.cruisemaster.cheapestDeparture);
    if (props.cabinprimarytypes.length > 0) {
      return <React.Fragment>
        {cp.priceGrids.map((grid, index) =>
          <div key={cp.id + "_" + index + "_" + grid.cabintypeId}>
            <span className="font-normal">1 x </span>
            {props.cabinprimarytypes.find(x => x.id == grid.cabintypeId).name}
            <span className="font-normal">, {sumOfPassengers(grid)} guests</span>
          </div>
        )}
      </React.Fragment>
    }
  }
  function getButtonClass(cp) {
    let bc = "px-2 py-1 hover:bg-orange-500 hover:rounded-lg hover:text-white";
    if (cp && cp.departure == props.cruisemaster.cheapestDeparture) {
      bc += " text-orange-500 font-bold";
    }

    return bc;
  }
  function showDatesToggle() {
    setShowAllDates(!showAllDates);
  }
  function renderDateButton(index, cp) {
    return <button value={index} key={'head-' + cp.id}
      className={getButtonClass(cp)}
      onClick={props.handleDateSelection.bind(this, index)}>
      {new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric"
      }).format(new Date(cp.departure))}
    </button>
  }

  function addDefaultImage(e) {
    e.target.onerror = null;
    e.target.src = "https://placeimg.com/120/100/nature?" + props.cruisemaster.id
  }
  const mdMedia = useMediaQuery('(min-width:768px)');
  const lgMedia = useMediaQuery('(min-width:1024px)');
  
  return (
    <div className={props.wrapperClass} >
      <div id="container" style={lgMedia ? desktopLayout : ipadVerticalLayout}
        className="bg-white grid gap-2 grid-cols-2 lg:grid-cols-8 w-full h-full border rounded p-3 lg:p-0 ">
        <div style={{ gridArea: 'shipImage' }}
          className="rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden">
          <img className="w-full" style={{ zIndex: -1 }}
            src={props.pictureserver + props.cruisemaster.ship.image} alt=""
            onError={addDefaultImage}
          />
        </div>
        {/*
          <div style={{ gridArea: 'itineraryImage' }}>
            <div className={imageClass}
              style={{ maxHeight: 'calc(100vh - 240px)', left: '20%' }}
              onClick={() => setShowBigImage(!showBigImage)}>
              <img src="/img/Barcelona_roundtrip.jpg" alt="Map" style={{ maxHeight: 'calc(100vh - 250px)' }} />
            </div>
            {showBigImage
              ?
              <Portal>
                <div className="z-50 fixed cursor-pointer rounded-lg border-solid border-4 border-gray-800 shadow-2xl">
                  <img ref={bigImageRef} onLoad={() => setImageLoaded(true)}
                    src="/img/Barcelona_roundtrip.jpg" alt="Map"
                    style={{ maxHeight: 'calc(100vh - 25px)', maxWidth: 'calc(100vw - 25px)' }} />
                  {!imageLoaded ? <span className="p-6">loading image...</span> : null}
                </div>
              </Portal>
              : null
            }
          </div>
           */}
        <div style={{ gridArea: 'headline' }} className="pt-3">
          <div className="flex flex-col text-gray-900 font-bold text-lg mb-2">
            {props.cruisemaster.name}
            <span className="text-sm py-2">Cruiseline: {props.cruisemaster.ship.cruiseline.name}</span>
          </div>
          <div>Ship: {props.cruisemaster.ship.name}</div>
        </div>
        <div style={{ gridArea: 'itinerary' }} className="pb-3">
          <div className="mb-2 text-left" >
            <span>Departure dates: </span>
            <div >
              {props.cruisemaster.cruisePackages.map((cp, index) =>
                showAllDates ?
                  renderDateButton(index, cp)
                  : index < 4 ?
                    renderDateButton(index, cp)
                    : null
              )}
              {(showAllDates && props.cruisemaster.cruisePackages.length > 4)
                || (!showAllDates && props.cruisemaster.cruisePackages.length > 4) ?
                <span className="underline text-xs whitespace-no-wrap cursor-pointer px-1"
                  onClick={showDatesToggle}>
                  {showAllDates ? "Fewer dates" : "More dates"}
                </span>
                : null}
            </div>
          </div>
          <div className="flex flex-wrap text-sm text-gray-600">
            <span className="whitespace-no-wrap">DEP: {props.cruisemaster.stopPointsCruiseOnly[0].name}</span>
            <span className="px-1">|</span>
            <span className="whitespace-no-wrap">
              ARR: {props.cruisemaster.stopPointsCruiseOnly[props.cruisemaster.stopPointsCruiseOnly.length - 1].name}
            </span>
            {props.cruisemaster.stopPointsCruiseOnly.length > 2
              ? <span className="whitespace-no-wrap px-1">
                (+{props.cruisemaster.stopPointsCruiseOnly.length - 2} stops)
                  </span>
              : null
            }
            <span className="underline text-xs whitespace-no-wrap cursor-pointer px-1"
              onClick={() => setShowItinerary(!showItinerary)}>
              Show itinerary
              </span>
            {showItinerary
              ? <Portal>
                <div ref={itineraryRef} id="itinerary"
                  className="z-50 fixed resize bg-white shadow rounded-lg border-solid border-2 border-gray-800"
                  style={{ maxHeight: 'calc(100vh - 50px)', maxWidth: 'calc(100vw - 150px)', left: 25 }}>
                  <div onClick={() => setShowItinerary(false)}
                    className="absolute ml-auto h-12 w-12 p-3 cursor-pointer text-gray-500 hover:text-gray-800"
                    style={{ right: 0 }}>
                    <svg className="fill-current " viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <title>Close</title>
                      <path d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                    </svg>
                  </div>
                  <Itinerary
                    cruisemasterId={props.cruisemaster.id}
                    //pictureserver={props.cruisemaster.pictureserver}
                    stopPoints={props.cruisemaster.stopPointsCruiseOnly}
                  //cruisepackages={props.cruisemaster.cruisePackages}
                  />
                  {/*
                    <DescriptionView
                      wrapperClass="flex flex-col md:flex-row m-3 bg-white border"
                      showNavigation={false}
                      selectedCruise={props.cruisemaster}
                      pictureserver={props.pictureserver}
                    />
                    */}
                </div>
              </Portal>
              : null
            }
          </div>
        </div>
        <div style={{ gridArea: 'price' }}
          className="relative lg:flex justify-end w-full text-gray-900 font-bold text-base pt-3">
          <div className="absolute lg:relative lg:w-full" style={lgMedia ? null : { top: 25, right: 0 }}>
            <div
              className="w-full bg-cruise_lightblue-secondary text-center px-5 py-1 rounded whitespace-no-wrap">
              
              <NumberFormat
                value={parseInt(props.cruisemaster.lowestPrice / 100)}
                displayType={'text'}
                decimalSeparator={','} thousandSeparator={'.'} prefix={'DKK '} />
            </div>
            <Breakpoint lg up>
              <div className=" text-sm pr-10 text-right">
                <span className="font-normal">total price</span>
                <div>{new Intl.DateTimeFormat("en-GB", {
                  day: "2-digit",
                  month: "long"
                }).format(new Date(props.cruisemaster.cheapestDeparture))}</div>
                <div className="whitespace-no-wrap">{renderCabintypes()}</div>
              </div>
            </Breakpoint>
          </div>
        </div>
        <div style={{ gridArea: 'extraInfo' }}
          className="flex flex-col justify-evenly lg:pr-8">
          <div className="mb-1 lg:mb-0">
            <PrimaryButton
              onClick={() => setShowPrice(!showPrice)}
              buttonText="More prices"
            />
          </div>
          {showPrice
            ? <Portal >
              <div ref={priceRef} id="price"
                className="fixed resize bg-white z-50 shadow rounded border-solid border border-gray-800 overflow-y-auto"
                style={{ maxHeight: 'calc(100vh - 40px)', maxWidth: '90%' }}>
                <div onClick={() => setShowPrice(false)}
                  className="ml-auto h-12 w-12 p-3 cursor-pointer text-gray-500 hover:text-gray-800"
                  style={{ right: 0 }}>
                  <svg className="fill-current " viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <title>Close</title>
                    <path d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                  </svg>
                </div>
                <div className="relative mx-auto w-11/12 pb-10">
                  <PriceView
                    wrapperClass=""
                    selectedCruise={props.cruisemaster}
                    pictureserver={props.pictureserver}
                    cabinprimarytypes={props.cabinprimarytypes}
                    showNavigation={false}
                    horizontal={false}
                    selectable={false}
                  />
                </div>
              </div>
            </Portal>
            : null}

          {/*
            <ViewManager
              cabinprimarytypes={props.cabinprimarytypes}
              selectedCruise={props.cruisemaster}
              selectedCabins={props.selectedCabins}
              pictureserver={props.pictureserver}
              token={props.match.params.token} />
            */}
          <PrimaryButton
            buttonText="See more"
            onClick={props.handleSelection}
          />
          {/*
              <Button value={props.cruisemaster.id} className="px-4 w-24"
                size="sm" color="orange" appearance="ghost"
                onClick={props.handleSelection}>
                See more
              </Button>
              */}
        </div>
      </div>
    </div>
  );
}

export default Cruisemaster;